import graphql__06a26b5c4a2080c04408 from "./__generated__/ArchiveMarketingEmailDialog_marketingEmail.graphql.ts";
import graphql__9e7f594ff4a497126956 from "./__generated__/ArchiveMarketingEmailDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import FormDialog from "./FormDialog";
import {useNavigate} from "react-router-dom";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";
import type {ArchiveMarketingEmailDialogMutation} from "./__generated__/ArchiveMarketingEmailDialogMutation.graphql";

type Props = {
    queryRef: any,
    handleCloseDialog: () => void
}

const ArchiveMarketingEmailDialog: React.FC<Props> = ({queryRef, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const marketingEmail = useFragment(
        graphql__06a26b5c4a2080c04408,
        queryRef
    );

    const handleSubmission = () => {
        commitMutationWithErrorHandling<ArchiveMarketingEmailDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__9e7f594ff4a497126956,
                variables: {
                    input: {
                        id: marketingEmail.id
                    }
                },
                onCompleted: () => {
                    handleCloseDialog();
                    navigate('/marketing/emails');
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToArchiveMarketingEmail'})
            }
        )
    }

    return (
        <FormDialog
            handleCloseDialog={handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={{}}
            headline={intl.formatMessage({id: 'dialog.ArchiveMarketingEmailDialog.headline'})}
            submitLabel={intl.formatMessage({id: 'button.archive'})}
            dangerous={true}
        >
            <p className="text-gray-600">
                {intl.formatMessage({id: 'dialog.ArchiveMarketingEmailDialog.confirmMessage'}, {name: marketingEmail.name})}
            </p>
        </FormDialog>
    )
}

export default ArchiveMarketingEmailDialog;
